export default "__VITE_ASSET__31479dfa__"